import LoginApi from '@/api-interface/login'
import CompanyApi from '@/api-interface/company'

export default {
  namespaced: true,

  state: {},

  getters: {},

  actions: {
    async registerUser({ commit }, userInfo) {
      const baseInfo = {
        // TODO: need to make this dynamic based on the type of registration
        accountType: 'shipper',
        carrier: null
      }

      const data = Object.assign({}, baseInfo, userInfo)

      await LoginApi.registerUser(data)

      // commit('user/SET_USER_INFO', response, { root: true })
      commit('SET_REGISTRATION_FLAG', true, { root: true })
    },

    async registerCompany({ commit, rootState }, companyInfo) {
      const baseInfo = {
        companyEquipmentPreferences: [],
        companyLanesRoutes: []
      }

      const data = Object.assign({}, baseInfo, companyInfo)
      let response

      // decide if we need to create/register a new company or update an existing one
      if (rootState['company'].currentCompanyInfo.companyKey) {
        const combinedData = Object.assign({}, rootState['company'].currentCompanyInfo, data)
        response = await CompanyApi.update(combinedData)
      } else {
        response = await CompanyApi.register(data)
      }

      commit('company/SET_COMPANY_INFO', response, { root: true })
      commit('SET_REGISTRATION_FLAG', true, { root: true })
    }
  }
}
